export const flattenObject = (obj: any, prefix = ''): any => {
    return Object.keys(obj).reduce((acc, k) => {
      const pre = prefix.length ? prefix + '.' : '';
      if (typeof obj[k] === 'object' && obj[k] !== null) {
        Object.assign(acc, flattenObject(obj[k], pre + k));
      } else {
        acc[pre + k] = obj[k];
      }
      return acc;
    }, {} as any);
  };

export function stringToArray(input: string, separator: string): string[] {
  return input.split(separator??',').map(item => item.trim());
}